<mat-card>
    <mat-card-header>
        <mat-card-title>Add Service Request.....................</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        @if (formFields?.length) {
        <app-dynamic-forms-v2 [formMetaData]="formMeta" [formFields]="formFields" (formSubmitted)="onSubmitted($event)">
        </app-dynamic-forms-v2>
        } @else {
        <div style="padding: 18px; opacity: 0.75;">Loading form…</div>
        }
    </mat-card-content>

    <div class="g-just-flex gap-10 justify-content-end p-12">
        <button mat-button (click)="close()">Close</button>
    </div>
</mat-card>